const volunteer_activism = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16 3.25C16.65 2.49 17.66 2 18.7 2C20.55 2 22 3.45 22 5.3C22 7.56315 19.1075 10.1841 16.028 12.9746L16 13L15.9341 12.94C12.8687 10.1526 10 7.54392 10 5.3C10 3.45 11.45 2 13.3 2C14.34 2 15.35 2.49 16 3.25ZM5 11H1V22H5V11ZM13 17H20C21.11 17 22 17.9 22.01 19L14 22L7 20.02V11H8.97L16.23 13.71C16.69 13.89 17 14.33 17 14.82C17 15.47 16.47 16 15.82 16H13L11.24 15.33L10.91 16.27L13 17Z" fill="black" />
  </svg>
);
export default volunteer_activism;
